/**
 * @name clinica-mvp
 * @author Fellipe Orsini
 * @package clinica-mvp\app\assets\js\crud_integration_facebook_lead_ads.js
 */

//import { apiCall, getBaseDir } from './utils.js';

var getBaseDir = null, apiCall = null;
var moment = require('moment-timezone');

$(function()
{
    import('../../utils.js').then(utils => {
        getBaseDir = utils.getBaseDir;
        apiCall = utils.apiCall;

        if (!utils.isUserLoggedIn())
            return;

        // A partir dessa parte só vai executar os códigos abaixo quando estiver na página inicial
        if (location.pathname !== getBaseDir() + 'integracoes/facebook-lead-ads')
            return;

        let fbAdsInstance = new FacebookAdsLeads(true, {
            getBaseDir: utils.getBaseDir,
            apiCall: utils.apiCall,
        });


    });
});

class FacebookAdsLeads {
    constructor(onloadList=false, deps = {}) {
        this.deps = deps;
        this.fbLoginData = false;

        if (onloadList) {
            this.startIntegrationCheck();
            this.bindChangePageAndReloadFormList();
        }

        this.callbackFacebookLoginStatus(null);
    }

    startIntegrationCheck() {
        let self = this;
        function OnBusinessReady() {
            console.log('crud_integration_facebook_lead_ads.js/startIntegrationCheck', 'OnBusinessReady');
        };
        window.businessReadyFunctions.push(OnBusinessReady);
    }

    callbackFacebookLoginStatus(response, isLoginButton=false) {
        console.log('crud_integration_facebook_lead_ads.js/callbackFacebookLoginStatus', response);
        let self = this;
        apiCall({
            method: 'POST',
            endpoint: 'api/v1/integrations/facebook-lead-ads/update-integration',
            data: {},
            successCallback: function(res) {
                if (!res.error) {
                    // Insert your code here
                    console.log('crud_integration_facebook_lead_ads.js/callbackFacebookLoginStatus/page list', res.pages);

                    if (res.error) {
                        window.toast({
                            error: 'true',
                            message: 'Ocorreu um erro ao resgatar suas páginas'
                        });
                    } else {
                        if (res.pages.length === 0) {
                            apiCall({
                                method: 'POST',
                                endpoint: 'api/v1/integrations/facebook-lead-ads/get-pages-list',
                                data: {},
                                successCallback: function(res) {
                                    if (res.error) {
                                        this.fbLoginData = false;

                                        $('.js-fb-lead-ads-integration-container').html(`
                                        <div class="text-center py-5 text-break">
                                            <p class="lead">Clique no botão de "Login" do Facebook para integrar seus formulários.</p>
                                        </div>`)
                                    } else {
                                        this.fbLoginData = res;
                                        $('.js-fb-lead-ads-integration-container').html(`
                                            <div class="py-5">
                                                <p class="lead text-break d-none">
                                                    Logado no fb, dados: ${JSON.stringify(response)}
                                                </p>
                                                <div class="container text-center">
                                                    <p class="lead">Selecione uma página</p>
                                                    <div class="row">
                                                        <div class="col-sm-12 col-md-6 col-lg-6 offset-md-2 mb-2">
                                                            <select class="js-lead-ads-pages-list form-control">
                                                            </select>
                                                        </div>
                                                        <div class="js-lead-ads-page-integration-button d-flex justify-content-start col-sm-12 col-md-4 col-lg-4"></div>
                                                    </div>
                                                </div>

                                                <div class="container js-lead-ads-page-form-list text-center my-2">
                                                </div>

                                                <div class="container old-js-lead-ads-page-form-combination my-2">

                                                </div>
                                            </div>
                                        `);

                                        let pagesListHtml = ''; 
                                        for(let i in res.pages) {
                                            let page = res.pages[i];
                                            pagesListHtml += `<option value="${page.id}" data-integration-on="${page.integration_active}">${page.name}</option>`
                                        }
                                        $('.js-lead-ads-pages-list').html(pagesListHtml);

                                        setTimeout(function() {
                                            $('.js-lead-ads-pages-list').trigger('change');
                                        }, 100);
                                        console.log('crud_integration_facebook_lead_ads.js/callbackFacebookLoginStatus/response', response);
                                    }
                                },
                                errorCallback: function(err) {
                                }
                            });
                        } else {
                            this.fbLoginData = res;

                            $('.js-fb-lead-ads-integration-container').html(`
                                <div class="py-5">
                                    <p class="lead text-break d-none">
                                        Logado no fb, dados: ${JSON.stringify(response)}
                                    </p>
                                    <div class="container text-center">
                                        <p class="lead">Selecione uma página</p>
                                        <div class="row">
                                            <div class="col-sm-12 col-md-6 col-lg-6 offset-md-2 mb-2">
                                                <select class="js-lead-ads-pages-list form-control">
                                                </select>
                                            </div>
                                            <div class="js-lead-ads-page-integration-button d-flex justify-content-start col-sm-12 col-md-4 col-lg-4"></div>
                                        </div>
                                    </div>

                                    <div class="container js-lead-ads-page-form-list text-center my-2">
                                    </div>

                                    <div class="container old-js-lead-ads-page-form-combination my-2">

                                    </div>
                                </div>
                            `);

                            let pagesListHtml = ''; 
                            for(let i in res.pages) {
                                let page = res.pages[i];
                                pagesListHtml += `<option value="${page.id}" data-integration-on="${page.integration_active}">${page.name}</option>`
                            }
                            $('.js-lead-ads-pages-list').html(pagesListHtml);

                            setTimeout(function() {
                                $('.js-lead-ads-pages-list').trigger('change');
                            }, 100);
                            console.log('crud_integration_facebook_lead_ads.js/callbackFacebookLoginStatus/response', response);
                        }
                    }
                }
            },
            errorCallback: function(err) {

            }
        })
    }

    bindChangePageAndReloadFormList() {
        let self = this;
        $(document).on('change', '.js-lead-ads-pages-list', function() {
            let pageId = $(this).val(),
                isIntegrationActive = $('.js-lead-ads-pages-list option:selected').data('integration-on');

            if (isIntegrationActive == true) {
                self.getPageFormlist(pageId);
                $('.js-lead-ads-page-integration-button').html(`
                    <button class="btn btn-danger js-lead-ads-page-remove-integration" data-page-id="${pageId}">Desativar integração</button>
                `);
            } else {
                $('.js-lead-ads-page-integration-button').html(`
                    <button class="btn btn-primary js-lead-ads-page-activate-integration" data-page-id="${pageId}">Ativar integração</button>
                `);
                $('.js-lead-ads-page-form-list').html('');
            }
        });

        $(document).on('click', '.js-lead-ads-page-activate-integration', function() {
            let pageId = $(this).data('page-id');
            apiCall({
                method: 'POST',
                endpoint: 'api/v1/integrations/facebook-lead-ads/start-integration',
                data: {
                    pageId: `${pageId}`
                },
                successCallback: function(res) {
                    if (res.error) {
                        window.toast({
                            error: true,
                            text: res.message
                        })
                    } else {
                        $(".js-lead-ads-pages-list > option").each(function() {
                            let optionPageId = $(this).val(),
                                optionIsIntegrationActive = $(this).data('integration-on');

                            if (optionPageId == pageId && optionIsIntegrationActive == false) {
                                $(this).data('integration-on', true);
                            }
                        });

                        let htmlList = `<br><p class="lead my-2">Formulários</p><button class="btn btn-info js-lead-ads-page-refresh-form-list" data-page-id="${pageId}">Atualizar</button>`;
                        for(let i in res.payload.integrations.fbLeadAds.pages) {
                            let page = res.payload.integrations.fbLeadAds.pages[i];
                            if (page.id == pageId) {
                                for(let x in page.form_list) {
                                    let form = page.form_list[x];
            
                                    htmlList += `<div class="row">
                                        <div class="py-2 col-sm-12 col-md-4 col-lg-4 offset-md-3 text-start">
                                            ${form.active ? `<button class="btn btn-success">Ativo</button>` : `<button class="btn btn-danger">Inativo</button>`}
                                            ${form.name}
                                        </div>
                                        <div class="py-2 col-sm-12 col-md-4 col-lg-4 d-flex justify-content-start">
                                            ${form.active ? `<button class="btn btn-secondary js-lead-ads-form-field-mapping" data-page-id="${pageId}" data-form-id="${form.id}" data-fields-map='${JSON.stringify(form.fields_map)}' data-form-name="${form.name}" data-bs-toggle="modal" data-bs-target="#modal-facebook-lead-ads-field-mapping">Combinar campos</button>` : ``}
                                        </div>
                                    </div>`;
                                }
                            }
                        }
                        $('.js-lead-ads-page-integration-button').html(`
                            <button class="btn btn-danger js-lead-ads-page-remove-integration" data-page-id="${pageId}">Desativar integração</button>
                        `);
                        $('.js-lead-ads-page-form-list').html(htmlList);
                    }
                },
                errorCallback: function(err) {
                    
                }
            })
        });
        
        $(document).on('click', '.js-lead-ads-page-remove-integration', function() {
            let pageId = $(this).data('page-id');
            apiCall({
                method: 'POST',
                endpoint: 'api/v1/integrations/facebook-lead-ads/remove-integration',
                data: {
                    pageId: `${pageId}`
                },
                successCallback: function(res) {
                    if (res.error) {
                        window.toast({
                            error: true,
                            text: res.message
                        })
                    } else {
                        $('.js-lead-ads-page-integration-button').html(`
                            <button class="btn btn-primary js-lead-ads-page-activate-integration" data-page-id="${pageId}">Ativar integração</button>
                        `);
                        $('.js-lead-ads-page-form-list').html('');
                    }
                },
                errorCallback: function(err) {
                    
                }
            })
        });

        $(document).on('click', '.js-lead-ads-form-combination-cancel', function() {
            $("#modal-facebook-lead-ads-field-mapping").modal('hide');
        });

        $(document).on('click', '.js-lead-ads-form-field-mapping', function() {
            let pageId = $(this).data('page-id'),
                formId = $(this).data('form-id'),
                fieldsMap = $(this).data('fields-map'),
                formName = $(this).data('form-name');
            
            if ($('.js-lead-ads-page-form-list').hasClass('d-none')) {
                //$('.js-lead-ads-page-form-list').removeClass('d-none');
                //$('.old-js-lead-ads-page-form-combination').addClass('d-none');
            } else {
                //$('.js-lead-ads-page-form-list').addClass('d-none');
                //$('.old-js-lead-ads-page-form-combination').removeClass('d-none');

                if (fieldsMap == null) {
                
                }

                let fieldsInputsHtml = '';
                let fieldsMapKeys = fieldsMap ? Object.keys(fieldsMap) : [];
                let count = 0;
                let combinationOptions = [
                    {
                        field: "Email",
                        value: "email"
                    },
                    {
                        field: "Nome",
                        value: "nome"
                    },
                    {
                        field: "Telefone",
                        value: "telefone"
                    },
                    {
                        field: "Celular",
                        value: "celular"
                    },
                    {
                        field: "Twitter",
                        value: "twitter"
                    },
                    {
                        field: "Facebook",
                        value: "facebook"
                    },
                    {
                        field: "LinkedIn",
                        value: "linkedin"
                    },
                    {
                        field: "Website",
                        value: "site_ou_blog"
                    },
                    {
                        field: "Estado",
                        value: "estado"
                    },
                    {
                        field: "Cidade",
                        value: "cidade"
                    },
                    {
                        field: "CPF",
                        value: "cpf"
                    },
                ]
                for(let i in fieldsMap) {
                    let field = fieldsMap[i],
                        fieldName = fieldsMapKeys[count],
                        combinationOptionsHtml = '',
                        fieldCombinationSet = false;

                    for(let x in combinationOptions) {
                        let combination_option = combinationOptions[x];
                        if (field == combination_option.value) {
                            fieldCombinationSet = true;
                        }
                        combinationOptionsHtml += `<option value="${combination_option.value}" ${field == combination_option.value ? 'selected' : ''}>${combination_option.field}</option>`;
                    }

                    //console.log('fieldCombinationSet', fieldCombinationSet);
                    if (!fieldCombinationSet) {
                        let newStr = '<option value="" selected disabled>Selecione</option>';
                        combinationOptionsHtml = newStr + combinationOptionsHtml;
                    } else {
                        let newStr = '<option value="" disabled>Selecione</option>';
                        combinationOptionsHtml = newStr + combinationOptionsHtml;
                    }
                    //console.log('combinationOptionsHtml', combinationOptionsHtml);

                    fieldsInputsHtml += `
                        <div class="row p-2">
                            <div class="col-4 offset-md-2">
                                <input type="text" class="form-control disabled js-lead-ads-field-name" value="${fieldName}" data-field-key="${i}" readonly />
                            </div>
                            <div class="col-4">
                                <select class="form-control js-lead-ads-update-mapping" data-field-key="${i}" data-field-name="${fieldName}" ${fieldName === 'email' ? 'disabled' : ''}>
                                    ${combinationOptionsHtml}
                                </select>
                            </div>
                        </div>
                    `;

                    count++;
                }

                $('.js-facebook-lead-ads-mapping-campaign-name').html(formName);
                $('.js-lead-ads-page-form-combination').html(`
                    <div class="text-center">
                        <br><h2>${formName}</h2>
                        <p class="lead my-2">Combine os campos do formulário com os do nosso sistema.</p>
                        <p class="lead my-2"><b>Os campos sem combinação não serão inseridos na sua base leads.</b></p>
                    </div>

                    <form class="js-lead-ads-save-field-mapping" data-page-id="${pageId}" data-form-id="${formId}">
                        ${fieldsInputsHtml}
                        <div class="d-flex justify-content-center">
                            <button type="button" class="btn btn-sm btn-secondary js-lead-ads-form-combination-cancel">Cancelar</button>
                            <button type="submit" class="btn btn-sm btn-primary ml-2 js-lead-ads-form-combination-save">Salvar</button>
                        </div>
                    </form>
                `);
            }
        });

        $(document).on('submit', '.js-lead-ads-save-field-mapping', function(e) {
            e.preventDefault();

            let pageId = $(this).data('page-id'),
                formId = $(this).data('form-id'),
                newFieldMap = {};

            $('.js-lead-ads-field-name').each(function() {
                let mapFieldName = $(this).val();
                newFieldMap[mapFieldName] = null;
            });

            $('.js-lead-ads-update-mapping').each(function() {
                let mapFieldName = $(this).data('field-name');
                let mapFieldValue = $(this).val();
                if (mapFieldValue == null||'') {
                    newFieldMap[mapFieldName] = mapFieldName;
                } else {
                    newFieldMap[mapFieldName] = mapFieldValue;
                }
            });

            /*console.log('pageId', pageId);
            console.log('formId', formId);
            console.log('newFieldMap', newFieldMap);*/

            apiCall({
                method: 'POST',
                endpoint: 'api/v1/integrations/facebook-lead-ads/update-combination',
                data: [
                    {name: 'pageId', value: `${pageId}`},
                    {name: 'formId', value: `${formId}`},
                    {name: 'newFieldMap', value: newFieldMap},
                ],
                successCallback: function(body) {
                    window.toast({
                        error: body.error,
                        text: body.message,
                    });

                    if (!body.error) {
                        $('.js-lead-ads-form-combination-cancel').trigger('click');

                        let htmlList = `<br><p class="lead my-2">Formulários</p><button class="btn btn-info js-lead-ads-page-refresh-form-list" data-page-id="${pageId}">Atualizar</button>`;
                        for(let i in body.payload.integrations.fbLeadAds.pages) {
                            let page = body.payload.integrations.fbLeadAds.pages[i];
                            if (page.id == pageId) {
                                for(let x in page.form_list) {
                                    let form = page.form_list[x];
            
                                    htmlList += `<div class="row">
                                        <div class="py-2 col-sm-12 col-md-4 col-lg-4 offset-md-3 text-start">
                                            ${form.active ? `<button class="btn btn-success">Ativo</button>` : `<button class="btn btn-danger">Inativo</button>`}
                                            ${form.name}
                                        </div>
                                        <div class="py-2 col-sm-12 col-md-4 col-lg-4 d-flex justify-content-start">
                                            ${form.active ? `<button class="btn btn-secondary js-lead-ads-form-field-mapping" data-page-id="${pageId}" data-form-id="${form.id}" data-fields-map='${JSON.stringify(form.fields_map)}' data-form-name="${form.name}" data-bs-toggle="modal" data-bs-target="#modal-facebook-lead-ads-field-mapping">Combinar campos</button>` : ``}
                                        </div>
                                    </div>`;
                                }
                            }
                        }
                        $('.js-lead-ads-page-form-list').html(htmlList);
                        $('#modal-facebook-lead-ads-field-mapping').modal('hide');
                    }
                },
                errorCallback: function(err) {

                }
            })
        });

        $(document).on('click', '.js-lead-ads-page-refresh-form-list', function() {
            let pageId = $(this).data('page-id');
            self.getPageFormlist(pageId, true, this);
        });
    }

    getFbPageList() {

    }

    getPageFormlist(pageId, isRefreshFormList = false, buttonObj = false) {
        if (buttonObj) {
            $(buttonObj).html('Atualizando...');
            $(buttonObj).attr('disabled', true);
        }
        apiCall({
            method: !isRefreshFormList ? 'GET' : 'POST',
            endpoint: !isRefreshFormList ? 'api/v1/integrations/facebook-lead-ads/get-forms' : 'api/v1/integrations/facebook-lead-ads/refresh-form-list',
            data: {
                pageId
            },
            successCallback: function(res) {
                if (buttonObj) {
                    window.toast({
                        error: res.error,
                        text: res.message
                    });
                    $(buttonObj).html('Atualizar');
                    $(buttonObj).attr('disabled', false);
                }
                if (res.error) {
                    window.toast({
                        error: true,
                        text: res.message
                    })
                } else {
                    let htmlList = `<br><p class="lead my-2">Formulários</p><button class="btn btn-info js-lead-ads-page-refresh-form-list" data-page-id="${pageId}">Atualizar</button>`;
                    for(let i in res.data) {
                        let form = res.data[i];

                        htmlList += `<div class="row">
                            <div class="py-2 col-sm-12 col-md-4 col-lg-4 offset-md-3 text-start">
                                ${form.active ? `<button class="btn btn-success">Ativo</button>` : `<button class="btn btn-danger">Inativo</button>`}
                                ${form.name}
                            </div>
                            <div class="py-2 col-sm-12 col-md-4 col-lg-4 d-flex justify-content-start">
                                ${form.active ? `<button class="btn btn-secondary js-lead-ads-form-field-mapping" data-page-id="${pageId}" data-form-id="${form.id}" data-fields-map='${JSON.stringify(form.fields_map)}' data-form-name="${form.name}" data-bs-toggle="modal" data-bs-target="#modal-facebook-lead-ads-field-mapping">Combinar campos</button>` : ``}
                            </div>
                        </div>`;
                    }
                    $('.js-lead-ads-page-form-list').html(htmlList);
                }
            },
            errorCallback: function(err) {
                if (buttonObj) {
                    $(buttonObj).html('Atualizar');
                    $(buttonObj).attr('disabled', false);
                }
            }
        })
    }
}